import firebase from "firebase/compat/app";
import "firebase/compat/auth";
import "firebase/compat/firestore";
import "firebase/compat/storage";
import "firebase/compat/database";

const config = {
  apiKey: "AIzaSyDi686kOAxYJgY2kMYkYmTIucuvzunGXW8",
  authDomain: "egyptiancoach-6a357.firebaseapp.com",
  databaseURL: "https://egyptiancoach-6a357.firebaseio.com",
  projectId: "egyptiancoach-6a357",
  storageBucket: "egyptiancoach-6a357.appspot.com",
  messagingSenderId: "309200165502",
  appId: "1:309200165502:web:66ddf435a548c7ec",
};
firebase.initializeApp(config);

export const auth = firebase.auth();
export const firestore = firebase.firestore();
export const database = firebase.database();
export const storage = firebase.storage();
export const facebookProvider = new firebase.auth.FacebookAuthProvider();
export const googleProvider = new firebase.auth.GoogleAuthProvider();
export const appleProvider = new firebase.auth.OAuthProvider("apple.com");

export default firebase;
